import React from 'react'
import styles from './TextoSeo.module.scss';
import { ISeo } from '@/components/templates/search/interfaces/IEstructuraPrincipal';

const decodeHTML = (str: string) => {
	return str.replace(/&#(\d+);/g, (match: string, dec: string) => {
		return String.fromCharCode(parseInt(dec));
	});
};

export const TextoSeo = ({ seoText }: ISeo) => {
	if (seoText === undefined) return null
	const { title, content } = seoText ?? {}

	return (
		<div className={styles.cTextoSeo}>
			<h2 className={styles.ttTextoSeo}>{title}</h2>
			<div className={styles.textoSeo} dangerouslySetInnerHTML={{ __html: decodeHTML(content) }} />
		</div>
	)
}